var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noDataContainer w-100",class:{ isFull: _vm.isFull }},[_c('div',{staticClass:"noData"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }